import RequestCompositions from 'actions/customer/request_compositions';
import requestCustomerExtension from 'actions/external_customer_lookup/request_customer_extension';
import RequestItemIds from 'actions/customer/request_item_ids';

export default function(context, customerId) {
  context.gateways.customerAssignee.request(customerId);
  context.gateways.customerHistory.requestConversations(customerId);
  context.gateways.customerHistory.subscribeToConversationItems(customerId);
  context.gateways.customerHistory.subscribeToMerge(customerId);
  context.gateways.customerProfile.request({ customerId });
  context.gateways.customerProfileMerge.subscribe({ customerId });
  context.gateways.customerNote.request({ customerId });
  context.gateways.customerTransaction.request({ customerId });
  context.gateways.customerActiveSecureDataRequests.subscribe({ customerId });

  context.executeAction(RequestItemIds, { customerId });

  let customerStores = context.stores.customers.storesFor(customerId);
  customerStores.assignee.setLoading();
  customerStores.conversationHistory.setLoading();
  customerStores.conversations.setLoading();
  customerStores.note.setLoading();
  customerStores.profile.setLoading();
  customerStores.transactions.setLoading();
  customerStores.activeSecureDataRequests.setLoading();

  context.executeAction(RequestCompositions, { customerId });

  if (context.stores.agentAssistanceConfig.get().isEnabled('topicSuggestions')) {
    context.stores.topicSuggestions.setLoading();
  }
  customerStores.relationships.setLoading();
  context.gateways.relationship.requestAll({ customerId });

  requestCustomerExtension(context, customerId);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/lib/request_customer.js